"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapcodeIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Snapcode_svg_1 = __importDefault(require("./Snapcode.svg"));
/**
 * Standard snapcode icon
 * See: https://www.figma.com/file/Qbp1aFBvMcOJIhjAzZCfTY/Atomic-Data?node-id=1717%3A9136&t=hDUaDiYARb3mJu3I-0
 */
function SnapcodeIcon() {
    return (0, jsx_runtime_1.jsx)(Snapcode_svg_1.default, {});
}
exports.SnapcodeIcon = SnapcodeIcon;
//# sourceMappingURL=index.js.map